"use strict";
window.addEventListener("hashchange", function() {
    if (window.location.hash === "#menu") document.body.classList.add("page__body--with-menu");
    else document.body.classList.remove("page__body--with-menu");
});
window.addEventListener("DOMContentLoaded", function() {
    var tabsList = document.querySelectorAll(".shop__tab-button");
    tabsList.forEach(function(tab) {
        tab.addEventListener("click", changeTabs);
    });
});
function changeTabs(e) {
    var targetTab = e.target;
    var tabsList = document.querySelectorAll(".shop__tab-button");
    var tabPanels = document.querySelectorAll(".shop__tab-products");
    tabsList.forEach(function(tab) {
        return tab.classList.remove("shop__tab-button--active");
    });
    targetTab.classList.add("shop__tab-button--active");
    tabPanels.forEach(function(panel) {
        if (panel.dataset.panel === targetTab.dataset.tab) panel.classList.remove("hidden");
        else panel.classList.add("hidden");
    });
}

//# sourceMappingURL=index.902d1920.js.map
